import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconStoreSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="24" height="24" viewBox="0 0 24 24" fill="none"
             className={classNames(['svg-icon svg-store', className])}>
                <path d="M0,0H24V24H0Z"/>
                <path fill={color}
                      d="M5,6H19a1,1,0,0,0,0-2H5A1,1,0,0,0,5,6ZM20.16,7.8a1,1,0,0,0-.98-.8H4.82a1,1,0,0,0-.98.8l-1,5A1,1,0,0,0,3.82,14H4v5a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V14h4v5a1,1,0,0,0,2,0V14h.18a1,1,0,0,0,.98-1.2ZM12,18H6V14h6Z"/>
        </svg>

    );
};

IconStoreSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconStoreSVG.defaultProps = {
    color: '#ffffff',
    className: '',
};

export default IconStoreSVG;




